<template>
  <div>
    <h1 class="text-h1 mb-16">This verification link is invalid</h1>
    <p class="pb-16 text-body text-grey-body">
      This link may have expired or already been used. Please contact our
      <a
        href="https://support.sittercity.com/hc/en-us/requests/new?ticket_form_id=5652055814427"
        class="underline"
        target="_blank"
        rel="noopener noreferrer"
        >support team</a
      >
      if you need assistance in upgrading with your employer-sponsored benefit.
    </p>
    <Button class="w-full" variant="primary" value="Go to dashboard" size="medium" to="/account/seekers/dashboard" />
  </div>
</template>

<script lang="ts">
import Button from '@/components/button/Button.vue';

export default {
  name: 'VerifyCorporateUpgradeInvalidLink',
  components: {
    Button,
  },
};
</script>
